import { render, staticRenderFns } from "./MenuLayout.vue?vue&type=template&id=5ff76368&scoped=true"
import script from "./MenuLayout.vue?vue&type=script&lang=js"
export * from "./MenuLayout.vue?vue&type=script&lang=js"
import style0 from "./MenuLayout.vue?vue&type=style&index=0&id=5ff76368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff76368",
  null
  
)

export default component.exports